import { jsx } from 'react/jsx-runtime';
import { IconBase } from '@vds/core';

const DownCaretBold = (props) => (jsx(IconBase, Object.assign({}, props, { svgContent: jsx("g", { id: "Layer_62", "data-name": "Layer 62", children: jsx("polygon", { points: "6 9.687 0.518 4.206 1.932 2.791 6 6.859 10.067 2.791 11.481 4.206 6 9.687" }) }), viewBox: "0 0 12 12", iconName: "down-caret-bold" })));
DownCaretBold.displayName = 'VDS_Icon';

export { DownCaretBold as default };
